import React from 'react';
import { DataTable } from '@/components/ui/datatable';
import { getDataRetentionColumns } from './columns';
import { DataRetentionRecordUI, toUI, fromUI } from '../dataTypeMapping';
import { DataRetentionSchedule } from '@/js/external-js/variableModules/namespaces/DataRetentionSchedule.namespace';
import DataRetentionTableCards from './DataRetentionTableCards';
type DataTypeEntity = DataRetentionSchedule.DataTypeEntity;

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = React.useState(false);
  React.useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < breakpoint);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, [breakpoint]);
  return isMobile;
}

interface DataRetentionTableProps {
  records: DataTypeEntity[];
  onView: (record: DataTypeEntity) => void;
  onDelete: (id: number) => void;
}

const DataRetentionTable: React.FC<DataRetentionTableProps> = ({ records, onView, onDelete }) => {
  const isMobile = useIsMobile();
  const uiRecords: DataRetentionRecordUI[] = records.map(toUI);
  const handleView = (uiRecord: DataRetentionRecordUI) => {
    onView(fromUI(uiRecord));
  };
  const columns = React.useMemo(() => getDataRetentionColumns(handleView, onDelete), [onView]);
  if (isMobile) {
    return <DataRetentionTableCards records={uiRecords} onView={handleView} pageSize={10} />;
  }
  return <DataTable columns={columns} data={uiRecords} pageSize={10} onDelete={onDelete} onRowClick={(record) => handleView(record)} />;
};

export default DataRetentionTable;
